export enum FormOfAddress {
  Personal = 'Personal',
  Formal = 'Formal'
}
